import styled from 'styled-components';

export const ColumnGuideWrapper = styled.div`
    display: ${(props) => (props.visible ? 'block' : 'none')};
    position: absolute;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.primary300};
    opacity: 0.2;
    top: 0;
    left: 0;
`;

export const ColumnControlWrapper = styled.div`
    cursor: default;
    position: absolute;
    width: 104px;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0 2px 4px 0 rgba(28,28,28,0.2);
    color: white;
    left: calc(50% - 47px);
    z-index: 1;
    outline: none;
`;
export const ColumnControlBox = styled.div`
    position: relative;
    height: 24px;
`;

export const JustifyDiv = styled.div`
    padding: 2px 0;
    cursor: pointer;
    width: 100px;
    position: absolute;
    top: 7px;
`;

export const JustifyText = styled.p`
    font-size: 9px;
    width: 100px;
    text-align: center;
    padding: 5px 0;
    font-style: italic;
    color: gray;
    :hover {
        color: black;
    }
`;

export const LeftIconDiv = styled.div`
    position: absolute;
    left: 0px;
    bottom: 0px;
`;

export const RightIconDiv = styled.div`
    position: absolute;
    right: 0px;
    bottom: 0px;
`;

export const IconSpan = styled.span`
    width: 14px;
    height: 14px;
    padding: 4px;
    cursor: pointer;
`;

export const SplitSpan = styled.span`
    padding: 2px;
    cursor: pointer;
    position: absolute;
    left: calc(50% - 10px);
`;

export const Icon = styled.i`
    width: 14px;
    height: 14px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.primary300};
    :hover {
        color: black;
    }
`;

export const MergeLeftIcon = styled(Icon)`
    transform: rotate(-90deg);
`;


export const SwapLeftIcon = styled(Icon)`
`;

export const MergeRightIcon = styled(Icon)`
    transform: rotate(90deg);

`;

export const SplitIcon = styled(Icon)`
`;
